import { useState, useEffect } from 'react';
const HealthPanel = ({ isOpen, onClose }) => {
    const [healthWindow, setHealthWindow] = useState(null);
    useEffect(() => {
        if (isOpen && !healthWindow) {
            // Open in new tab instead of popup window
            const newWindow = window.open('', '_blank');
            if (!newWindow) {
                console.error('Failed to open health panel window');
                return;
            }
            window.gridchatHealthPanel = newWindow;
            setHealthWindow(newWindow);
            // Generate initial HTML structure
            newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Health Panel - GridChat</title>
            <style>
              * { margin: 0; padding: 0; box-sizing: border-box; }
              
              body {
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%);
                color: white;
                overflow-x: hidden;
              }

              .overlay {
                min-height: 100vh;
                display: flex;
                justify-content: center;
                align-items: flex-start;
                padding: 20px;
              }

              .panel {
                background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%);
                border-radius: 12px;
                width: 100%;
                max-width: 1400px;
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
                display: flex;
                flex-direction: column;
              }

              .header {
                padding: 20px 30px;
                border-bottom: 2px solid rgba(139, 92, 246, 0.3);
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: rgba(0, 0, 0, 0.2);
              }

              .title {
                margin: 0;
                color: white;
                font-size: 24px;
                font-weight: 600;
              }

              .header-buttons {
                display: flex;
                gap: 10px;
              }

              .theme-btn {
                background: rgba(139, 92, 246, 0.2);
                border: 1px solid #8b5cf6;
                color: white;
                padding: 8px 16px;
                border-radius: 8px;
                cursor: pointer;
                font-size: 14px;
                transition: all 0.2s;
              }

              .theme-btn:hover {
                background: rgba(139, 92, 246, 0.3);
              }

              .content {
                padding: 20px 30px;
                overflow-y: auto;
                max-height: calc(100vh - 100px);
              }

              .section {
                margin-bottom: 30px;
              }

              .section-title {
                color: white;
                font-size: 18px;
                margin-bottom: 15px;
                font-weight: 600;
                display: flex;
                align-items: center;
                gap: 8px;
              }

              .stats-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
                gap: 12px;
                margin-bottom: 20px;
              }

              .stat-card {
                background: rgba(0, 0, 0, 0.3);
                border: 1px solid rgba(139, 92, 246, 0.3);
                border-radius: 8px;
                padding: 12px;
                transition: all 0.2s;
              }

              .stat-card:hover {
                background: rgba(0, 0, 0, 0.4);
                border-color: rgba(139, 92, 246, 0.5);
              }

              .stat-label {
                color: rgba(255, 255, 255, 0.7);
                font-size: 11px;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                margin-bottom: 8px;
              }

              .stat-value {
                color: white;
                font-size: 24px;
                font-weight: 700;
                margin-bottom: 4px;
                line-height: 1;
              }

              .stat-value-small {
                color: white;
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 4px;
              }

              .stat-sublabel {
                color: rgba(255, 255, 255, 0.5);
                font-size: 10px;
                margin-top: 4px;
              }

              .stat-bar {
                height: 4px;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 2px;
                overflow: hidden;
                margin-top: 8px;
              }

              .stat-bar-fill {
                height: 100%;
                transition: width 0.3s ease, background-color 0.3s ease;
                border-radius: 2px;
              }

              .stream-card {
                background: rgba(0, 0, 0, 0.2);
                border: 2px solid rgba(139, 92, 246, 0.3);
                border-radius: 12px;
                padding: 20px;
                margin-bottom: 20px;
              }

              .stream-header {
                margin-bottom: 20px;
                padding-bottom: 15px;
                border-bottom: 1px solid rgba(139, 92, 246, 0.2);
              }

              .loading {
                text-align: center;
                padding: 60px 20px;
                color: rgba(255, 255, 255, 0.7);
                font-size: 16px;
              }

              .error {
                text-align: center;
                padding: 40px 20px;
                color: #ef4444;
                font-size: 14px;
              }
            </style>
          </head>
          <body>
            <div class="overlay">
              <div class="panel">
                <div class="header">
                  <h2 class="title">ðŸ¥ Health Panel</h2>
                  <div class="header-buttons">
                    <button class="theme-btn" onclick="toggleTheme()">
                      <span id="theme-icon">â˜€ï¸ Light</span>
                    </button>
                  </div>
                </div>

                <div class="content" id="health-content">
                  <div class="loading">â³ Loading health data...</div>
                </div>
              </div>
            </div>

            <script>
              let isDark = true;
              let updateInterval;

              function toggleTheme() {
                isDark = !isDark;
                document.getElementById('theme-icon').textContent = isDark ? 'â˜€ï¸ Light' : 'ðŸŒ™ Dark';
              }

              function formatBytes(bytes) {
                if (!bytes || bytes === 0) return '0 B';
                const k = 1024;
                const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
                const i = Math.floor(Math.log(bytes) / Math.log(k));
                return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
              }

              function formatUptime(seconds) {
                if (!seconds) return '0s';
                const days = Math.floor(seconds / 86400);
                const hours = Math.floor((seconds % 86400) / 3600);
                const mins = Math.floor((seconds % 3600) / 60);
                const secs = Math.floor(seconds % 60);
                
                if (days > 0) return days + 'd ' + hours + 'h ' + mins + 'm';
                if (hours > 0) return hours + 'h ' + mins + 'm ' + secs + 's';
                return mins + 'm ' + secs + 's';
              }

              function getStatusColor(value, threshold) {
                if (value < threshold * 0.5) return '#10b981';
                if (value < threshold * 0.75) return '#f59e0b';
                return '#ef4444';
              }

              async function updateHealthData() {
                try {
                  const response = await fetch('/api/health-stats');
                  
                  if (!response.ok) {
                    throw new Error('API request failed: ' + response.status);
                  }
                  
                  const stats = await response.json();
                  console.log('Health stats received:', stats);

                  let html = '';

                  // Check if we have stream data
                  if (!stats.activeStreams || stats.activeStreams.length === 0) {
                    html = '<div class="loading">â³ No active streams. Start a stream with /stream command</div>';
                    document.getElementById('health-content').innerHTML = html;
                    return;
                  }

                  // Active Streams Section
                  html += '<div class="section">';
                  html += '<h3 class="section-title">ðŸ“º Active Streams (' + stats.activeStreams.length + ')</h3>';
                  
                  stats.activeStreams.forEach(stream => {
                    html += '<div class="stream-card">';
                    
                    // Stream Header
                    html += '<div class="stream-header">';
                    html += '<h3 style="margin: 0; font-size: 16px; color: #a78bfa;">ðŸ“º ' + stream.id + '</h3>';
                    html += '<div style="font-size: 11px; color: rgba(255,255,255,0.5); margin-top: 4px;">';
                    html += 'Uptime: ' + (stream.uptime || '0:00') + ' â€¢ Started: ' + new Date(stream.startedAt).toLocaleTimeString();
                    html += '</div></div>';

                    // Stats Grid
                    html += '<div class="stats-grid">';
                    
                    // FFmpeg Process Stats
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ’» FFmpeg CPU</div>';
                    html += '<div class="stat-value" style="color: ' + getStatusColor(stream.cpu || 0, 100) + '">' + (stream.cpu?.toFixed(1) || 0) + '%</div>';
                    html += '<div class="stat-bar"><div class="stat-bar-fill" style="width: ' + (stream.cpu || 0) + '%; background: ' + getStatusColor(stream.cpu || 0, 100) + '"></div></div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ§  RAM Usage</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stream.memory || 0) + '</div>';
                    html += '<div class="stat-sublabel">' + (stream.memoryPercent?.toFixed(1) || 0) + '% of system</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ†” Process ID</div>';
                    html += '<div class="stat-value-small">' + (stream.pid || 'N/A') + '</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ’¾ Disk Usage</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stream.diskUsage || 0) + '</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ“¦ HLS Segments</div>';
                    html += '<div class="stat-value-small">' + (stream.segments || 0) + '</div>';
                    html += '</div>';
                    
                    // Network Stats - UPDATED WITH CLEARER LABELS
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">â¬‡ï¸ Input Bitrate</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stream.inputBitrate || 0) + '/s</div>';
                    html += '<div class="stat-sublabel">From source stream</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">â¬†ï¸ Output Rate</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stream.uploadRate || 0) + '/s</div>';
                    html += '<div class="stat-sublabel">To viewers</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ“Š Total Served</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stream.outputBytesServed || 0) + '</div>';
                    html += '<div class="stat-sublabel">To ' + (stream.viewers || 0) + ' viewer' + (stream.viewers === 1 ? '' : 's') + '</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ‘¥ Viewers</div>';
                    html += '<div class="stat-value-small">' + (stream.viewers || 0) + '</div>';
                    html += '</div>';
                    
                    // Encoding Stats
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸŽ¬ FPS</div>';
                    html += '<div class="stat-value-small">' + (stream.fps || 0) + '</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">âš¡ Encoding Speed</div>';
                    html += '<div class="stat-value-small">' + (stream.encodingSpeed?.toFixed(2) || 0) + 'x</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ“‰ Dropped Frames</div>';
                    html += '<div class="stat-value-small">' + (stream.droppedFrames || 0) + '</div>';
                    html += '</div>';
                    
                    // Health Monitoring Stats
                    const healthColor = stream.healthStatus === 'healthy' ? '#10b981' : 
                                       stream.healthStatus === 'stalled' ? '#f59e0b' :
                                       stream.healthStatus === 'recovering' ? '#3b82f6' : '#ef4444';
                    const healthIcon = stream.healthStatus === 'healthy' ? 'âœ… Healthy' :
                                      stream.healthStatus === 'stalled' ? 'âš ï¸ Stalled' :
                                      stream.healthStatus === 'recovering' ? 'ðŸ”„ Recovering' : 'âŒ Failed';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ¥ Health Status</div>';
                    html += '<div class="stat-value-small" style="color: ' + healthColor + '">' + healthIcon + '</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">â¸ï¸ Total Stalls</div>';
                    html += '<div class="stat-value-small" style="color: ' + (stream.stallCount === 0 ? '#10b981' : '#f59e0b') + '">' + (stream.stallCount || 0) + '</div>';
                    html += '<div class="stat-sublabel">' + (stream.stallCount === 0 ? 'No stalls âœ…' : 'Stream stalled ' + stream.stallCount + ' times') + '</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ”„ Auto-Recoveries</div>';
                    html += '<div class="stat-value-small" style="color: ' + (stream.totalRecoveries === 0 ? '#10b981' : '#3b82f6') + '">' + (stream.totalRecoveries || 0) + '</div>';
                    html += '<div class="stat-sublabel">' + (stream.totalRecoveries === 0 ? 'No restarts needed âœ…' : 'Restarted ' + stream.totalRecoveries + ' times') + '</div>';
                    html += '</div>';
                    
                    if (stream.lastStallTime) {
                      html += '<div class="stat-card">';
                      html += '<div class="stat-label">â±ï¸ Last Stall</div>';
                      html += '<div class="stat-value-small">' + Math.floor((Date.now() - stream.lastStallTime) / 1000) + 's ago</div>';
                      html += '</div>';
                    }
                    
                    if (stream.recoveryStartTime) {
                      html += '<div class="stat-card">';
                      html += '<div class="stat-label">â³ Restart In</div>';
                      html += '<div class="stat-value-small" style="color: #3b82f6;">' + Math.max(0, 5 - Math.floor((Date.now() - stream.recoveryStartTime) / 1000)) + 's</div>';
                      html += '<div class="stat-sublabel">Recovery countdown</div>';
                      html += '</div>';
                    }
                    
                    if (stream.consecutiveErrors > 0) {
                      html += '<div class="stat-card">';
                      html += '<div class="stat-label">âš ï¸ Error Streak</div>';
                      html += '<div class="stat-value-small" style="color: #ef4444;">' + stream.consecutiveErrors + '</div>';
                      html += '<div class="stat-sublabel">Consecutive errors</div>';
                      html += '</div>';
                    }
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ§Š Frame Status</div>';
                    html += '<div class="stat-value-small" style="color: ' + (stream.frameFreezeDetected ? '#ef4444' : '#10b981') + '">';
                    html += stream.frameFreezeDetected ? 'Frozen â„ï¸' : 'Flowing âœ…';
                    html += '</div></div>';
                    
                    html += '</div>'; // End stats-grid
                    
                    // Stream Source URL at bottom
                    html += '<div style="margin-top: 16px; padding: 12px; background: rgba(0,0,0,0.3); border-radius: 8px; font-size: 11px; color: rgba(255,255,255,0.7);">';
                    html += '<strong>ðŸ“¡ Source:</strong> ' + stream.sourceUrl;
                    html += '</div>';
                    
                    html += '</div>'; // End stream-card
                  });
                  
                  html += '</div>'; // End section

                  // Server Health Section
                  if (stats.serverHealth) {
                    html += '<div class="section">';
                    html += '<h3 class="section-title">ðŸ–¥ï¸ Server Health</h3>';
                    html += '<div class="stats-grid">';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ’» Server CPU</div>';
                    html += '<div class="stat-value" style="color: ' + getStatusColor(stats.serverHealth.cpu || 0, 100) + '">' + (stats.serverHealth.cpu?.toFixed(1) || 0) + '%</div>';
                    html += '<div class="stat-bar"><div class="stat-bar-fill" style="width: ' + (stats.serverHealth.cpu || 0) + '%; background: ' + getStatusColor(stats.serverHealth.cpu || 0, 100) + '"></div></div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ§  Server RAM</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stats.serverHealth.memory?.used || 0) + '</div>';
                    html += '<div class="stat-sublabel">of ' + formatBytes(stats.serverHealth.memory?.total || 0) + '</div>';
                    const memPercent = ((stats.serverHealth.memory?.used || 0) / (stats.serverHealth.memory?.total || 1)) * 100;
                    html += '<div class="stat-bar"><div class="stat-bar-fill" style="width: ' + memPercent + '%; background: ' + getStatusColor(memPercent, 100) + '"></div></div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ“Š Load Average</div>';
                    html += '<div class="stat-value-small">' + (stats.serverHealth.loadAverage?.[0]?.toFixed(2) || 0) + '</div>';
                    html += '<div class="stat-sublabel">1m: ' + (stats.serverHealth.loadAverage?.[0]?.toFixed(2) || 0) + ' | 5m: ' + (stats.serverHealth.loadAverage?.[1]?.toFixed(2) || 0) + ' | 15m: ' + (stats.serverHealth.loadAverage?.[2]?.toFixed(2) || 0) + '</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">â±ï¸ Server Uptime</div>';
                    html += '<div class="stat-value-small">' + formatUptime(stats.serverHealth.uptime || 0) + '</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ’¾ Disk Space</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stats.serverHealth.diskSpace?.used || 0) + '</div>';
                    html += '<div class="stat-sublabel">of ' + formatBytes(stats.serverHealth.diskSpace?.total || 0) + '</div>';
                    const diskPercent = ((stats.serverHealth.diskSpace?.used || 0) / (stats.serverHealth.diskSpace?.total || 1)) * 100;
                    html += '<div class="stat-bar"><div class="stat-bar-fill" style="width: ' + diskPercent + '%; background: ' + getStatusColor(diskPercent, 100) + '"></div></div>';
                    html += '</div>';
                    
                    html += '</div></div>'; // End stats-grid and section
                  }

                  // Network Section
                  if (stats.network) {
                    html += '<div class="section">';
                    html += '<h3 class="section-title">ðŸŒ Network (' + (stats.network.interface || 'N/A') + ')</h3>';
                    html += '<div class="stats-grid">';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">â¬‡ï¸ Download Rate</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stats.network.rxRate || 0) + '/s</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">â¬†ï¸ Upload Rate</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stats.network.txRate || 0) + '/s</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ“¥ Total Downloaded</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stats.network.rxTotal || 0) + '</div>';
                    html += '</div>';
                    
                    html += '<div class="stat-card">';
                    html += '<div class="stat-label">ðŸ“¤ Total Uploaded</div>';
                    html += '<div class="stat-value-small">' + formatBytes(stats.network.txTotal || 0) + '</div>';
                    html += '</div>';
                    
                    html += '</div></div>'; // End stats-grid and section
                  }

                  document.getElementById('health-content').innerHTML = html;

                } catch (error) {
                  console.error('Error fetching health data:', error);
                  document.getElementById('health-content').innerHTML = 
                    '<div class="error">âŒ Error loading health data<br><small>' + error.message + '</small></div>';
                }
              }

              // Start updating
              updateHealthData();
              updateInterval = setInterval(updateHealthData, 2000);

              // Cleanup on window close
              window.addEventListener('beforeunload', () => {
                if (updateInterval) clearInterval(updateInterval);
              });
            </script>
          </body>
        </html>
      `);
            // Handle window close
            const checkClosed = setInterval(() => {
                if (newWindow.closed) {
                    clearInterval(checkClosed);
                    setHealthWindow(null);
                    onClose();
                }
            }, 1000);
        }
    }, [isOpen, healthWindow, onClose]);
    // Cleanup on component unmount
    useEffect(() => {
        return () => {
            if (healthWindow && !healthWindow.closed) {
                healthWindow.close();
            }
        };
    }, [healthWindow]);
    return null;
};
export default HealthPanel;
